import React, { createContext, useContext, useState, useMemo } from 'react';

// Lets the project card stack hand its current controls (prev/next/pause/photo/clock-in/…) up to
// the global FAB bar, so in card view the bar SWAPS its tabs for those controls. ProjectScreen
// publishes a config while it's in card view and clears it on leave; FabTabBar renders it.
const Ctx = createContext(null);

export function CardActionProvider({ children }) {
  const [cardBar, setCardBar] = useState(null);
  const value = useMemo(() => ({ cardBar, setCardBar }), [cardBar]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useCardActions() {
  return useContext(Ctx) || { cardBar: null, setCardBar: () => {} };
}
